import { render, staticRenderFns } from "./CouponResults.vue?vue&type=template&id=2e8a5ac2&scoped=true&"
import script from "./CouponResults.vue?vue&type=script&lang=js&"
export * from "./CouponResults.vue?vue&type=script&lang=js&"
import style0 from "./CouponResults.vue?vue&type=style&index=0&id=2e8a5ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8a5ac2",
  null
  
)

export default component.exports